var module = angular.module('octopusApp.environments');

module.directive('offlineDropEndpoint', function() {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      endpoint: '='
    },
    templateUrl: 'areas/environments/views/endpoints/offline_drop_endpoint.html'
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/environments/directives/endpoints/offline_drop_endpoint.js
// module id = 8328700954260467
// module chunks = 1